frappe.ui.form.EmailGroupQuickEntryForm = class extends frappe.ui.form.QuickEntryForm {
	// @dokos
	set_meta_and_mandatory_fields() {
		super.set_meta_and_mandatory_fields();
		const source_fieldnames = new Set(["import_doctype", "auto_update", "import_filters_display"]);
		const quick_entry_fieldnames = new Set(this.docfields.map((df) => df.fieldname));
		const source_fields = this.meta.fields.filter(
			(df) => source_fieldnames.has(df.fieldname) && !quick_entry_fieldnames.has(df.fieldname)
		);
		this.docfields = [...this.docfields, ...source_fields].map((df) => ({ ...df }));

		for (const fieldname of ["import_doctype", "auto_update", "import_filters_display"]) {
			const field = this.docfields.find((df) => df.fieldname === fieldname);
			field.hidden = fieldname !== "import_doctype";
			field.depends_on = null;
		}
	}

	// @dokos
	render_dialog() {
		super.render_dialog();

		const options = {
			email_group_type: "Service\nMarketing",
			default_legal_basis: "Consent (Opt-In)\nLegitimate Interest\nContractual Necessity",
		};

		for (const [fieldname, values] of Object.entries(options)) {
			const field = this.fields_dict[fieldname];
			field.df.options = values;
			field.set_options();
		}

		this.fields_dict.membership_mode.after_set_value = () => {
			setTimeout(() => {
				this.update_source_field_visibility();
				this.update_filter_widget();
			}, 150);
		};
		this.fields_dict.import_doctype.after_set_value = () => {
			setTimeout(() => this.update_filter_widget(), 150);
		};
		this.update_source_field_visibility();
		this.update_filter_widget();
	}

	// @dokos
	refresh_dependency() {
		super.refresh_dependency();
		if (!this.fields_dict?.membership_mode) return;

		this.update_source_field_visibility();
		this.update_filter_widget();
	}

	// @dokos
	update_source_field_visibility() {
		const show_fields = this.fields_dict.membership_mode.get_value() === "Dynamic";

		for (const fieldname of ["import_doctype", "auto_update"]) {
			const field = this.fields_dict[fieldname];
			field.df.hidden_due_to_dependency = false;
			field.toggle(show_fields);
			field.$wrapper.toggleClass("hide-control", !show_fields);
		}
	}

	// @dokos
	update_filter_widget() {
		const doctype = this.fields_dict.import_doctype.get_value();
		const show_filters =
			this.fields_dict.membership_mode.get_value() === "Dynamic" && Boolean(doctype);
		const field = this.fields_dict.import_filters_display;
		field.df.hidden_due_to_dependency = false;
		field.toggle(show_filters);
		field.$wrapper.toggleClass("hide-control", !show_filters);

		if (this._filter_group_doctype && this._filter_group_doctype !== doctype) {
			this.doc.import_filters = "[]";
			this._filter_group.wrapper.empty();
			this._filter_group = null;
			this._filter_group_doctype = null;
		}

		if (!show_filters || this._filter_group) return;

		const wrapper = field.$wrapper;
		wrapper.empty();
		this._filter_group_doctype = doctype;
		this._filter_group = new frappe.ui.FilterGroup({
			parent: wrapper,
			doctype,
			on_change: () => {
				this.doc.import_filters = JSON.stringify(this._filter_group.get_filters());
			},
		});
		this._filter_group.wrapper.find(".apply-filters").hide();

		const filter_group = this._filter_group;
		frappe.model.with_doctype(doctype, () => {
			if (this._filter_group !== filter_group) return;

			const filters = JSON.parse(this.doc.import_filters || "[]");
			filter_group.add_filters_to_filter_group(filters);
		});
	}

	// @dokos
	update_doc(data = this.get_values(true)) {
		const doc = super.update_doc(data);
		if (doc.membership_mode !== "Dynamic") {
			doc.import_doctype = null;
			doc.auto_update = 0;
			doc.import_filters = null;
		} else if (this._filter_group) {
			doc.import_filters = JSON.stringify(this._filter_group.get_filters());
		}
		return doc;
	}
};
